import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SelectHookForm from '../../ui/selects/SelectHookForm';
import {
  numberOfEmployeesOptions,
  monthlyRevenueOptions,
  lastYearTaxesFiledOptions,
} from './formOptions';

export const FormGroup = styled.div`
  align-items: center;
  display: grid;
  grid-gap: 16px;
  grid-template-columns: '1fr';
  padding-bottom: 16px;
`;

const CompanyDetailsForm = ({ client, isLoading }) => (
  <>
    <FormGroup>
      <SelectHookForm
        name="numberOfEmployees"
        ariaLabel="Company Size"
        isSearchable={false}
        isDisabled={isLoading}
        defaultValue={client.numberOfEmployees}
        options={numberOfEmployeesOptions}
        helperText="Select number of owners, employees, and contractors"
        rules={{
          required: { value: true, message: 'Company size is required' },
        }}
        label="Company Size"
      />
    </FormGroup>
    <FormGroup>
      <SelectHookForm
        name="monthlyRevenue"
        ariaLabel="Monthly Revenue"
        isDisabled={isLoading}
        isSearchable={false}
        defaultValue={client.monthlyRevenue}
        options={monthlyRevenueOptions}
        helperText="Select average monthly revenue before deductions"
        rules={{
          required: { value: true, message: 'Monthly revenue is required' },
        }}
        label="Monthly Revenue"
      />
    </FormGroup>
    <FormGroup>
      <SelectHookForm
        name="lastYearTaxesFiled"
        ariaLabel="Last Tax Return"
        isSearchable={false}
        isDisabled={isLoading}
        defaultValue={client.lastYearTaxesFiled}
        options={lastYearTaxesFiledOptions}
        helperText="Select most recent business income tax filing"
        rules={{
          required: { value: true, message: 'Last tax return is required' },
        }}
        label="Last Tax Return"
      />
    </FormGroup>
  </>
);

CompanyDetailsForm.propTypes = {
  isLoading: PropTypes.bool,
  client: PropTypes.object.isRequired,
};

CompanyDetailsForm.defaultProps = {
  isLoading: false,
};

export default CompanyDetailsForm;
